// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"9c38579a","453":"b1428ecc","702":"0f40d687"}[chunkId] + ".chunk.js";
};